import { render, staticRenderFns } from "./SendMailActionDescription.vue?vue&type=template&id=6a9dc390&"
import script from "./SendMailActionDescription.vue?vue&type=script&lang=js&"
export * from "./SendMailActionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports